<template>
  <LayoutSidePage
    :owner="currentOwner"
    :to-visit="{ name: 'ExplorerMapVisit', query: { owners: currentOwner ? currentOwner.id : null } }"
    :to-contribute="{ name: 'ExplorerMapContribute', query: { owners: currentOwner ? currentOwner.id : null } }"
  >
    <Hero
      :title="currentOwner && $te(`owners.${currentOwner.slug}.slogan`) ? $t(`owners.${currentOwner.slug}.slogan`) : $t('pages.home.slogan')"
      :subtitle="currentOwner && $te(`owners.${currentOwner.slug}.slogan_exp`) ? $t(`owners.${currentOwner.slug}.slogan_exp`) : $t('pages.home.slogan_exp')"
      :to-visit="{ name: 'ExplorerMapVisit', query: { owners: currentOwner ? currentOwner.id : null, owner_bbox: true } }"
      :to-contribute="{ name: 'ExplorerMapContribute', query: { owners: currentOwner ? currentOwner.id : null, owner_bbox: true } }"
    />
    <TimeMachine />
    <Infos
      :title="currentOwner ? currentOwner.name : $t('pages.home.infos.title')"
      :description="currentOwner ? currentOwner.description : $t('pages.home.infos.description')"
      :owner="currentOwner"
    />
    <Challenge
      v-if="currentOwner"
      :owner="currentOwner"
    />
    <Collections
      :owner="currentOwner"
      :title="currentOwner && $te(`owners.${currentOwner.slug}.collections_title`) ? $t(`owners.${currentOwner.slug}.collections_title`) : $t('general.collections')"
    />
    <UsersRanking
      v-if="currentOwner"
      :owner="currentOwner"
    />
  </LayoutSidePage>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { defineAsyncComponent } from 'vue';

const Hero = defineAsyncComponent(() => import('@/components/sidePage/SidePageHero'));
const TimeMachine = defineAsyncComponent(() => import('@/components/sidePage/SidePageTimeMachine'));
const Infos = defineAsyncComponent(() => import('@/components/sidePage/SidePageInfos'));
const Challenge = defineAsyncComponent(() => import('@/components/sidePage/SidePageChallenge'));
const UsersRanking = defineAsyncComponent(() => import('@/components/sidePage/SidePageUsersRanking'));
const Collections = defineAsyncComponent(() => import('@/components/sidePage/SidePageCollections'));

export default {
  name: 'OwnerSlug',

  components: {
    Hero,
    TimeMachine,
    Infos,
    Challenge,
    UsersRanking,
    Collections
  },

  computed: {
    currentOwner() {
      return (!this.owners) ? null : this.owners.filter(owner => owner.slug === this.$route.params.ownerSlug)[0];
    },

    ...mapState('metadata', ['owners'])
  },

  created() {
    const loadOwners = this.owners.length === 0 ? this.loadOwners() : Promise.resolve();

    Promise.all([loadOwners]).then(() => {
      if (typeof this.currentOwner === 'undefined') {
        this.$router.replace({ path: '/' });
      }
    });
  },

  mounted() {
    window.prerenderReady = true; // For pre-rendering SEO purpose
  },

  metaInfo() {
    return {
      title: `Smapshot ${this.currentOwner?.name || ''}`,
      titleTemplate: null,
      meta: [
        { vmid: 'description', name: 'description', content: this.$te(`owners.${this.currentOwner?.slug}.slogan_exp`) ? this.$t(`owners.${this.currentOwner?.slug}.slogan_exp`) : this.$t('pages.home.slogan_exp') },
        { vmid: 'og:description', property: 'og:description', content: this.$te(`owners.${this.currentOwner?.slug}.slogan_exp`) ? this.$t(`owners.${this.currentOwner?.slug}.slogan_exp`) : this.$t('pages.home.slogan_exp') },
        { vmid: 'thumbnail', property: 'thumbnail', content: this.currentOwner?.media?.banner_url },
        { vmid: 'og:image', property: 'og:image', content: this.currentOwner?.media?.banner_url },
        { vmid: 'og:image:width', property: 'og:image:width', content: '500' },
        { vmid: 'twitter:image', property: 'twitter:image', content: this.currentOwner?.media?.banner_url }
      ]
    };
  },

  methods: {
    ...mapActions('metadata', ['loadOwners'])
  }
};
</script>
